
export { LucideIcon } from "/codebuild/output/src190029547/src/packages/shared-components/src/components/LucideIcon.tsx"